/**
 * 左侧模块栏的开合（只影响窄屏）。
 *
 * ⚠ 为什么要一个 store 而不是 `useState`：抽屉画在**根布局**里，而打开它的那颗按钮
 *   在**各页自己的标题栏**里（两个模块的标题栏内容完全不同，硬提到根布局会把它们
 *   揉成一个满是条件判断的组件）。跨这两处的只有一个布尔值，放 store 最直接。
 * ⚠ 宽屏（`md` 起）模块栏是常驻的，这个值在那边**不参与渲染** —— 见 app-sidebar.tsx。
 */
import { create } from 'zustand'

interface NavState {
  sidebarOpen: boolean
  openSidebar: () => void
  closeSidebar: () => void
  toggleSidebar: () => void
}

export const useNavStore = create<NavState>()((set) => ({
  sidebarOpen: false,
  openSidebar: () => {
    set({ sidebarOpen: true })
  },
  closeSidebar: () => {
    set({ sidebarOpen: false })
  },
  toggleSidebar: () => {
    set((state) => ({ sidebarOpen: !state.sidebarOpen }))
  },
}))
